import {
    GET_INVOICE_SETTING_LIST_PROGRESS, GET_INVOICE_SETTING_LIST_SUCCESS, GET_INVOICE_SETTING_LIST_FAILURE,
    ADD_INVOICE_SETTING_PROGRESS, ADD_INVOICE_SETTING_SUCCESS, ADD_INVOICE_SETTING_FAILURE,
    EDIT_DELETE_INVOICE_SETTING_PROGRESS, EDIT_DELETE_INVOICE_SETTING_SUCCESS, EDIT_DELETE_INVOICE_SETTING_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    invoiceSetting: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const invoice_setting_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_INVOICE_SETTING_LIST_SUCCESS:
            return { ...state, invoiceSetting: action.invoiceSetting, loading: false };
        case GET_INVOICE_SETTING_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_INVOICE_SETTING_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_INVOICE_SETTING_PROGRESS:
            return { ...state, loading: true };
        case ADD_INVOICE_SETTING_SUCCESS:
            return { ...state, invoiceSetting: [...state.invoiceSetting, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_INVOICE_SETTING_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_INVOICE_SETTING_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_INVOICE_SETTING_SUCCESS:
            return {
                ...state,
                invoiceSetting: state.invoiceSetting.map((invoiceSetting) =>
                    invoiceSetting.id === action.payload.id ? action.payload : invoiceSetting
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_INVOICE_SETTING_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message};

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default invoice_setting_reducer;